"use client";
import Section from "./_components/common/section";
import {
  GlobeAsiaAustraliaIcon,
  HomeIcon,
  NewspaperIcon,
  SquaresPlusIcon,
} from "@heroicons/react/24/outline";
import { type Metadata } from "next";
import Link from "next/link";
import { getMetadata } from "~/app/utils/seo/metadataUtils";
import {
  CommunityAndSustainability,
  Home,
  Insights,
  Services,
} from "~/content/navLinks";

export async function generateMetadata(): Promise<Metadata> {
  return getMetadata("", "Something went wrong | Incluso"); // ?: not overriding the original page title
}

export default function Error500Page() {
  const linkClass = `mt-3 flex items-center text-green-light transition hover:text-green`;
  const iconClass = `mr-2 h-6 w-6`;
  return (
    <Section
      flexHeight
      className={`min-h-[min(50vh,875px)] flex-1 bg-gradient-blue1 text-white`}
    >
      <div className="px-12 py-20 text-center">
        <h1 className="text-desk-resp-4xl mb-12 font-bold text-green-light">
          Oops!
        </h1>
        <h2 className="text-desk-resp-2xl font-bold">Something went wrong</h2>

        <div className="text-resp-lg mx-auto mt-8 w-fit text-start">
          <p>Here are some handy links to explore:</p>
          <ul className="mt-6">
            <Link className={linkClass} href={Home.href}>
              <HomeIcon className={iconClass} /> Home
            </Link>
            <Link className={linkClass} href={Services.href}>
              <SquaresPlusIcon className={iconClass} /> Services
            </Link>
            <Link className={linkClass} href={Insights.href}>
              <NewspaperIcon className={iconClass} /> Insights
            </Link>
            <Link className={linkClass} href={CommunityAndSustainability.href}>
              <GlobeAsiaAustraliaIcon className={iconClass} /> Community &
              Sustainability
            </Link>
          </ul>
        </div>
      </div>
    </Section>
  );
}
